/**
 * Instant Search Filter - Custom Filter System for Search Drawer
 * Uses unique classes with "instant_search_filter_bs" suffix to avoid conflicts
 * Does NOT modify URL - filters work internally only
 * Filter options come from the Boost search API with build_filter_tree=true
 */

console.log('[Instant Search Filter BS] Script loaded');

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    SHOP_DOMAIN: 'elie-tahari.myshopify.com',
    API_BASE_URL: 'https://services.mybcapps.com/bc-sf-filter/search',
    PRODUCTS_PER_PAGE: 24
  };

  // State management
  const FilterState = {
    currentSearchTerm: '',
    selectedFilters: {},
    currentSort: 'relevance',
    filterTree: [],
    isDrawerOpen: false,
    totalProducts: 0
  };

  // DOM Element references
  let elements = {};

  /**
   * Initialize the instant search filter system
   */
  function init() {
    console.log('[Instant Search Filter BS] Initializing...');
    cacheElements();
    bindEvents();
    console.log('[Instant Search Filter BS] Initialized, elements:', elements);
  }

  /**
   * Cache DOM elements for performance
   */
  function cacheElements() {
    elements = {
      drawer: document.getElementById('instant_search_filter_bs_drawer'),
      overlay: document.getElementById('instant_search_filter_bs_overlay'),
      closeBtn: document.getElementById('instant_search_filter_bs_close_btn'),
      sortToggle: document.getElementById('instant_search_filter_bs_sort_toggle'),
      sortOptions: document.getElementById('instant_search_filter_bs_sort_options'),
      refineBy: document.getElementById('instant_search_filter_bs_refine_by'),
      refineItems: document.getElementById('instant_search_filter_bs_refine_items'),
      clearAllBtn: document.getElementById('instant_search_filter_bs_clear_all'),
      filterTree: document.getElementById('instant_search_filter_bs_tree'),
      viewResultsBtn: document.getElementById('instant_search_filter_bs_view_results'),
      openFilterBtn: document.getElementById('instant-search-open-filter-drawer')
    };
  }

  /**
   * Bind event listeners
   */
  function bindEvents() {
    console.log('[Instant Search Filter BS] Binding events...');
    
    // Open filter drawer button - using event delegation on document with capture phase
    document.addEventListener('click', function(e) {
      // Check for filter button click
      const filterBtn = e.target.closest('#instant-search-open-filter-drawer');
      if (filterBtn) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[Instant Search Filter BS] Filter button clicked!');
        openDrawer();
        return;
      }
    }, true); // Use capture phase to ensure we get the event first

    // Close button - using event delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('#instant_search_filter_bs_close_btn')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    // Overlay click to close - using event delegation
    document.addEventListener('click', function(e) {
      if (e.target.matches('#instant_search_filter_bs_overlay') || e.target.matches('.instant_search_filter_bs_overlay')) {
        closeDrawer();
      }
    });

    // Sort toggle - using event delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('#instant_search_filter_bs_sort_toggle')) {
        toggleSortOptions();
      }
    });

    // Sort option selection - using event delegation
    document.addEventListener('click', function(e) {
      const sortOption = e.target.closest('.instant_search_filter_bs_sort_option');
      if (sortOption) {
        handleSortChange(sortOption);
      }
    });

    // Clear all filters - using event delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('#instant_search_filter_bs_clear_all')) {
        clearAllFilters();
      }
    });

    // View results button - using event delegation
    document.addEventListener('click', function(e) {
      if (e.target.closest('#instant_search_filter_bs_view_results')) {
        closeDrawer();
        applyFiltersAndSearch();
      }
    });

    // Filter tree event delegation
    document.addEventListener('click', function(e) {
      const filterTreeTarget = e.target.closest('#instant_search_filter_bs_tree');
      if (filterTreeTarget) {
        handleFilterTreeClick(e);
      }
    });

    // Escape key to close drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && FilterState.isDrawerOpen) {
        closeDrawer();
      }
    });

    // Listen for search term changes from the main search
    document.addEventListener('instant-search-term-changed', function(e) {
      if (e.detail && e.detail.searchTerm) {
        FilterState.currentSearchTerm = e.detail.searchTerm;
        // Reset filters when search term changes
        clearAllFilters(false);
        fetchFilterTree(e.detail.searchTerm);
      }
    });
  }

  /**
   * Open the filter drawer
   */
  function openDrawer() {
    // Always re-cache elements when opening drawer (they might have been dynamically added)
    cacheElements();
    
    console.log('[Instant Search Filter BS] Opening drawer, elements:', elements);

    if (elements.drawer) {
      elements.drawer.classList.add('instant_search_filter_bs_drawer_active');
      console.log('[Instant Search Filter BS] Drawer class added');
    } else {
      console.error('[Instant Search Filter BS] Drawer element not found!');
      return;
    }
    
    if (elements.overlay) {
      elements.overlay.classList.add('instant_search_filter_bs_overlay_active');
    }
    
    FilterState.isDrawerOpen = true;
    document.body.style.overflow = 'hidden';

    // Get search term from multiple sources
    var searchTerm = getSearchTerm();
    console.log('[Instant Search Filter BS] Search term found:', searchTerm);
    
    if (searchTerm) {
      FilterState.currentSearchTerm = searchTerm;
      fetchFilterTree(searchTerm);
    } else {
      console.warn('[Instant Search Filter BS] No search term found');
      renderEmptyFilterTree();
    }
  }
  
  /**
   * Get search term from various sources
   */
  function getSearchTerm() {
    // 1. Check URL parameters (for search page)
    var urlParams = new URLSearchParams(window.location.search);
    var urlSearchTerm = urlParams.get('q');
    if (urlSearchTerm && urlSearchTerm.trim()) {
      console.log('[Instant Search Filter BS] Got search term from URL:', urlSearchTerm);
      return urlSearchTerm.trim();
    }
    
    // 2. Check the instant search input
    var searchInput = document.querySelector('.custom-search-input');
    if (searchInput && searchInput.value.trim()) {
      console.log('[Instant Search Filter BS] Got search term from .custom-search-input:', searchInput.value.trim());
      return searchInput.value.trim();
    }
    
    // 3. Check alternative search input selectors
    var altInputs = [
      'input[name="q"]',
      '.search-input',
      '#search-input',
      '.custom_search_form input[type="text"]',
      '.custom_search_form input[type="search"]'
    ];
    
    for (var i = 0; i < altInputs.length; i++) {
      var input = document.querySelector(altInputs[i]);
      if (input && input.value && input.value.trim()) {
        console.log('[Instant Search Filter BS] Got search term from', altInputs[i], ':', input.value.trim());
        return input.value.trim();
      }
    }
    
    // 4. Check if there's a stored search term
    if (FilterState.currentSearchTerm) {
      return FilterState.currentSearchTerm;
    }
    
    return null;
  }

  /**
   * Close the filter drawer
   */
  function closeDrawer() {
    // Re-cache elements in case they weren't found before
    cacheElements();
    
    if (elements.drawer) {
      elements.drawer.classList.remove('instant_search_filter_bs_drawer_active');
    }
    if (elements.overlay) {
      elements.overlay.classList.remove('instant_search_filter_bs_overlay_active');
    }
    
    FilterState.isDrawerOpen = false;
    document.body.style.overflow = '';
    
    console.log('[Instant Search Filter BS] Drawer closed');
  }

  /**
   * Toggle sort options visibility
   */
  function toggleSortOptions() {
    // Re-cache elements
    cacheElements();
    
    if (elements.sortOptions) {
      elements.sortOptions.classList.toggle('instant_search_filter_bs_sort_options_active');
    }
    if (elements.sortToggle) {
      elements.sortToggle.classList.toggle('instant_search_filter_bs_sort_header_active');
    }
  }

  /**
   * Handle sort option change
   */
  function handleSortChange(selectedOption) {
    const sortValue = selectedOption.getAttribute('data-sort-value');
    FilterState.currentSort = sortValue;

    // Update active state
    const allOptions = elements.sortOptions.querySelectorAll('.instant_search_filter_bs_sort_option');
    allOptions.forEach(function(opt) {
      opt.classList.remove('is_active_bs');
    });
    selectedOption.classList.add('is_active_bs');

    // Apply filters with new sort
    applyFiltersAndSearch();
  }

  /**
   * Fetch filter tree from the API
   */
  function fetchFilterTree(searchTerm) {
    if (!searchTerm) {
      console.warn('[Instant Search Filter BS] No search term provided to fetchFilterTree');
      renderEmptyFilterTree();
      return;
    }

    showFilterLoading();

    var url = CONFIG.API_BASE_URL + '?q=' + encodeURIComponent(searchTerm) + '&shop=' + CONFIG.SHOP_DOMAIN + '&build_filter_tree=true&limit=' + CONFIG.PRODUCTS_PER_PAGE;

    console.log('[Instant Search Filter BS] Fetching filter tree from:', url);

    fetch(url, { method: 'GET' })
      .then(function(response) {
        console.log('[Instant Search Filter BS] API Response status:', response.status);
        if (!response.ok) {
          throw new Error('Failed to fetch filter tree - Status: ' + response.status);
        }
        return response.json();
      })
      .then(function(data) {
        console.log('[Instant Search Filter BS] API Response data:', data);
        
        if (data && data.filter && data.filter.options && data.filter.options.length > 0) {
          FilterState.filterTree = data.filter.options;
          FilterState.totalProducts = data.total_product || 0;
          console.log('[Instant Search Filter BS] Filter options found:', data.filter.options.length);
          renderFilterTree(data.filter.options);
        } else {
          console.warn('[Instant Search Filter BS] No filter options in response');
          renderEmptyFilterTree();
        }
      })
      .catch(function(error) {
        console.error('[Instant Search Filter BS] Error fetching filter tree:', error);
        renderEmptyFilterTree();
      });
  }

  /**
   * Show loading state for filter tree
   */
  function showFilterLoading() {
    // Re-cache elements if needed
    if (!elements.filterTree) {
      elements.filterTree = document.getElementById('instant_search_filter_bs_tree');
    }
    
    if (elements.filterTree) {
      elements.filterTree.innerHTML = '<div class="instant_search_filter_bs_loading"><span>Loading filters...</span></div>';
      console.log('[Instant Search Filter BS] Showing loading state');
    } else {
      console.error('[Instant Search Filter BS] Filter tree element not found for loading state');
    }
  }

  /**
   * Render empty filter tree state
   */
  function renderEmptyFilterTree() {
    // Re-cache elements if needed
    if (!elements.filterTree) {
      elements.filterTree = document.getElementById('instant_search_filter_bs_tree');
    }
    
    if (elements.filterTree) {
      elements.filterTree.innerHTML = '<div class="instant_search_filter_bs_empty"><span>No filters available</span></div>';
      console.log('[Instant Search Filter BS] Showing empty state');
    } else {
      console.error('[Instant Search Filter BS] Filter tree element not found for empty state');
    }
  }

  /**
   * Render the filter tree from API data
   */
  function renderFilterTree(filterOptions) {
    // Re-cache elements if needed
    if (!elements.filterTree) {
      elements.filterTree = document.getElementById('instant_search_filter_bs_tree');
    }
    
    if (!elements.filterTree) {
      console.error('[Instant Search Filter BS] Filter tree element not found for rendering');
      return;
    }
    
    if (!filterOptions || !filterOptions.length) {
      console.warn('[Instant Search Filter BS] No filter options to render');
      renderEmptyFilterTree();
      return;
    }

    console.log('[Instant Search Filter BS] Rendering', filterOptions.length, 'filter options');
    var html = '';

    filterOptions.forEach(function(option, index) {
      // Skip if no values
      if (!option.values || option.values.length === 0) return;

      const filterType = option.filterType || option.filter_type || 'list';
      const filterKey = option.filterOptionId || option.id || option.label;
      const filterLabel = option.label || option.title || filterKey;
      const displayType = option.displayType || option.display_type || 'list';
      const isCollapsed = index > 0; // Collapse all except first

      html += `
        <div class="instant_search_filter_bs_option" data-filter-key="${filterKey}" data-filter-type="${filterType}">
          <div class="instant_search_filter_bs_option_header ${isCollapsed ? '' : 'instant_search_filter_bs_option_header_active'}">
            <span class="instant_search_filter_bs_option_title">${filterLabel}</span>
            <svg class="instant_search_filter_bs_option_arrow" width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.5 7.00195L7.75 1.00195L0.999998 7.00195" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="instant_search_filter_bs_option_content ${isCollapsed ? '' : 'instant_search_filter_bs_option_content_active'}">
            ${renderFilterValues(option, filterKey, displayType)}
          </div>
        </div>
      `;
    });

    elements.filterTree.innerHTML = html;
  }

  /**
   * Render filter values based on display type
   */
  function renderFilterValues(option, filterKey, displayType) {
    const values = option.values || [];
    
    // Check if this is a color/swatch filter
    const isColorFilter = filterKey.toLowerCase().includes('color') || 
                         option.label.toLowerCase().includes('color') ||
                         displayType === 'swatch';

    // Check if this is a price filter
    const isPriceFilter = filterKey.toLowerCase().includes('price') || 
                         option.filterType === 'range';

    if (isPriceFilter && option.min !== undefined && option.max !== undefined) {
      return renderPriceFilter(option, filterKey);
    }

    let html = '<ul class="instant_search_filter_bs_values_list">';

    values.forEach(function(value) {
      const valueKey = value.key || value.value || value.title || value;
      const valueLabel = value.title || value.label || value.key || value;
      const valueCount = value.doc_count || value.count || 0;
      const isSelected = isFilterSelected(filterKey, valueKey);

      if (isColorFilter) {
        html += renderColorSwatch(filterKey, valueKey, valueLabel, valueCount, isSelected);
      } else {
        html += `
          <li class="instant_search_filter_bs_value_item ${isSelected ? 'instant_search_filter_bs_value_selected' : ''}"
              data-filter-key="${filterKey}"
              data-filter-value="${valueKey}">
            <span class="instant_search_filter_bs_checkbox">
              <svg class="instant_search_filter_bs_check_icon" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4L4.5 7.5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span class="instant_search_filter_bs_value_label">${valueLabel}</span>
            <span class="instant_search_filter_bs_value_count">(${valueCount})</span>
          </li>
        `;
      }
    });

    html += '</ul>';
    return html;
  }

  /**
   * Render color swatch filter value
   */
  function renderColorSwatch(filterKey, valueKey, valueLabel, valueCount, isSelected) {
    const colorValue = valueLabel.toLowerCase().replace(/\s+/g, '');
    
    return `
      <li class="instant_search_filter_bs_swatch_item ${isSelected ? 'instant_search_filter_bs_value_selected' : ''}"
          data-filter-key="${filterKey}"
          data-filter-value="${valueKey}">
        <span class="instant_search_filter_bs_swatch" style="background-color: ${colorValue};" title="${valueLabel}">
          <svg class="instant_search_filter_bs_swatch_check" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4L4.5 7.5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="instant_search_filter_bs_swatch_label">${valueLabel}</span>
      </li>
    `;
  }

  /**
   * Render price range filter
   */
  function renderPriceFilter(option, filterKey) {
    const min = option.min || 0;
    const max = option.max || 1000;
    
    return `
      <div class="instant_search_filter_bs_price_range">
        <div class="instant_search_filter_bs_price_inputs">
          <div class="instant_search_filter_bs_price_input_group">
            <span class="instant_search_filter_bs_price_currency">$</span>
            <input type="number" 
                   class="instant_search_filter_bs_price_input instant_search_filter_bs_price_min" 
                   data-filter-key="${filterKey}"
                   min="${min}" 
                   max="${max}" 
                   value="${min}"
                   placeholder="Min">
          </div>
          <span class="instant_search_filter_bs_price_separator">-</span>
          <div class="instant_search_filter_bs_price_input_group">
            <span class="instant_search_filter_bs_price_currency">$</span>
            <input type="number" 
                   class="instant_search_filter_bs_price_input instant_search_filter_bs_price_max" 
                   data-filter-key="${filterKey}"
                   min="${min}" 
                   max="${max}" 
                   value="${max}"
                   placeholder="Max">
          </div>
        </div>
        <button class="instant_search_filter_bs_price_apply" data-filter-key="${filterKey}">Apply</button>
      </div>
    `;
  }

  /**
   * Handle clicks within the filter tree
   */
  function handleFilterTreeClick(e) {
    const target = e.target;

    // Handle option header click (expand/collapse)
    const optionHeader = target.closest('.instant_search_filter_bs_option_header');
    if (optionHeader) {
      toggleFilterOption(optionHeader);
      return;
    }

    // Handle filter value selection
    const valueItem = target.closest('.instant_search_filter_bs_value_item, .instant_search_filter_bs_swatch_item');
    if (valueItem) {
      handleFilterValueClick(valueItem);
      return;
    }

    // Handle price filter apply
    const priceApplyBtn = target.closest('.instant_search_filter_bs_price_apply');
    if (priceApplyBtn) {
      handlePriceFilterApply(priceApplyBtn);
      return;
    }
  }

  /**
   * Toggle filter option expand/collapse
   */
  function toggleFilterOption(header) {
    header.classList.toggle('instant_search_filter_bs_option_header_active');
    
    const content = header.nextElementSibling;
    if (content) {
      content.classList.toggle('instant_search_filter_bs_option_content_active');
    }
  }

  /**
   * Handle filter value click
   */
  function handleFilterValueClick(valueItem) {
    const filterKey = valueItem.getAttribute('data-filter-key');
    const filterValue = valueItem.getAttribute('data-filter-value');

    if (!filterKey || !filterValue) return;

    // Toggle selection
    if (isFilterSelected(filterKey, filterValue)) {
      removeFilter(filterKey, filterValue);
      valueItem.classList.remove('instant_search_filter_bs_value_selected');
    } else {
      addFilter(filterKey, filterValue);
      valueItem.classList.add('instant_search_filter_bs_value_selected');
    }

    updateRefineBySection();
    applyFiltersAndSearch();
  }

  /**
   * Handle price filter apply
   */
  function handlePriceFilterApply(button) {
    const filterKey = button.getAttribute('data-filter-key');
    const container = button.closest('.instant_search_filter_bs_price_range');
    
    if (!container) return;

    const minInput = container.querySelector('.instant_search_filter_bs_price_min');
    const maxInput = container.querySelector('.instant_search_filter_bs_price_max');

    if (minInput && maxInput) {
      const minValue = parseFloat(minInput.value) || 0;
      const maxValue = parseFloat(maxInput.value) || 1000;
      const priceValue = `${minValue}:${maxValue}`;

      // Remove any existing price filter and add new one
      FilterState.selectedFilters['price'] = [priceValue];
      updateRefineBySection();
      applyFiltersAndSearch();
    }
  }

  /**
   * Check if a filter value is selected
   */
  function isFilterSelected(filterKey, filterValue) {
    const filters = FilterState.selectedFilters[filterKey];
    return filters && filters.includes(filterValue);
  }

  /**
   * Add a filter value
   */
  function addFilter(filterKey, filterValue) {
    if (!FilterState.selectedFilters[filterKey]) {
      FilterState.selectedFilters[filterKey] = [];
    }
    if (!FilterState.selectedFilters[filterKey].includes(filterValue)) {
      FilterState.selectedFilters[filterKey].push(filterValue);
    }
  }

  /**
   * Remove a filter value
   */
  function removeFilter(filterKey, filterValue) {
    if (FilterState.selectedFilters[filterKey]) {
      const index = FilterState.selectedFilters[filterKey].indexOf(filterValue);
      if (index > -1) {
        FilterState.selectedFilters[filterKey].splice(index, 1);
      }
      if (FilterState.selectedFilters[filterKey].length === 0) {
        delete FilterState.selectedFilters[filterKey];
      }
    }
  }

  /**
   * Clear all filters
   */
  function clearAllFilters(applyAfterClear) {
    FilterState.selectedFilters = {};
    FilterState.currentSort = 'relevance';

    // Update sort options UI
    if (elements.sortOptions) {
      const allOptions = elements.sortOptions.querySelectorAll('.instant_search_filter_bs_sort_option');
      allOptions.forEach(function(opt) {
        opt.classList.remove('is_active_bs');
        if (opt.getAttribute('data-sort-value') === 'relevance') {
          opt.classList.add('is_active_bs');
        }
      });
    }

    // Update filter tree UI
    if (elements.filterTree) {
      const selectedItems = elements.filterTree.querySelectorAll('.instant_search_filter_bs_value_selected');
      selectedItems.forEach(function(item) {
        item.classList.remove('instant_search_filter_bs_value_selected');
      });
    }

    updateRefineBySection();

    if (applyAfterClear !== false) {
      applyFiltersAndSearch();
    }
  }

  /**
   * Update the refine by / applied filters section
   */
  function updateRefineBySection() {
    if (!elements.refineBy || !elements.refineItems) return;

    const hasFilters = Object.keys(FilterState.selectedFilters).length > 0;

    if (!hasFilters) {
      elements.refineBy.style.display = 'none';
      return;
    }

    elements.refineBy.style.display = 'block';

    let html = '';
    
    for (const filterKey in FilterState.selectedFilters) {
      const values = FilterState.selectedFilters[filterKey];
      values.forEach(function(value) {
        const displayValue = value.includes(':') ? `$${value.replace(':', ' - $')}` : value;
        html += `
          <div class="instant_search_filter_bs_refine_item" 
               data-filter-key="${filterKey}" 
               data-filter-value="${value}">
            <span class="instant_search_filter_bs_refine_item_label">${filterKey}: ${displayValue}</span>
            <button class="instant_search_filter_bs_refine_item_remove" aria-label="Remove filter">&times;</button>
          </div>
        `;
      });
    }

    elements.refineItems.innerHTML = html;

    // Bind remove button events
    const removeButtons = elements.refineItems.querySelectorAll('.instant_search_filter_bs_refine_item_remove');
    removeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const item = btn.closest('.instant_search_filter_bs_refine_item');
        if (item) {
          const filterKey = item.getAttribute('data-filter-key');
          const filterValue = item.getAttribute('data-filter-value');
          removeFilter(filterKey, filterValue);

          // Update filter tree UI
          const treeItem = elements.filterTree.querySelector(
            `[data-filter-key="${filterKey}"][data-filter-value="${filterValue}"]`
          );
          if (treeItem) {
            treeItem.classList.remove('instant_search_filter_bs_value_selected');
          }

          updateRefineBySection();
          applyFiltersAndSearch();
        }
      });
    });
  }

  /**
   * Build filter parameters for API request
   */
  function buildFilterParams() {
    const params = [];

    for (const filterKey in FilterState.selectedFilters) {
      const values = FilterState.selectedFilters[filterKey];
      
      values.forEach(function(value) {
        const key = filterKey.toLowerCase();
        
        // Map filter keys to Boost PFS parameter names
        if (key.includes('product_type') || key.includes('type') || key.includes('category')) {
          params.push(`pf_pt_category=${encodeURIComponent(value)}`);
        } else if (key.includes('size')) {
          params.push(`pf_opt_size=${encodeURIComponent(value)}`);
        } else if (key.includes('color')) {
          const colorValue = value.startsWith('COLOR_') ? value : 'COLOR_' + value;
          params.push(`pf_t_color=${encodeURIComponent(colorValue)}`);
        } else if (key.includes('vendor') || key.includes('brand')) {
          params.push(`pf_v_vendor=${encodeURIComponent(value)}`);
        } else if (key === 'price') {
          params.push(`pf_p_price=${encodeURIComponent(value)}`);
        } else if (key.includes('collection')) {
          params.push(`pf_c_collection=${encodeURIComponent(value)}`);
        } else {
          // Generic tag filter
          params.push(`pf_t_${key}=${encodeURIComponent(value)}`);
        }
      });
    }

    return params.join('&');
  }

  /**
   * Apply filters and trigger search
   */
  function applyFiltersAndSearch() {
    if (!FilterState.currentSearchTerm) {
      const searchInput = document.querySelector('.custom-search-input');
      if (searchInput && searchInput.value.trim()) {
        FilterState.currentSearchTerm = searchInput.value.trim();
      }
    }

    if (!FilterState.currentSearchTerm) return;

    const filterParams = buildFilterParams();
    
    // Dispatch custom event with filter data for the main search handler
    document.dispatchEvent(new CustomEvent('instant-search-filter-applied', {
      detail: {
        searchTerm: FilterState.currentSearchTerm,
        filters: FilterState.selectedFilters,
        filterParams: filterParams,
        sort: FilterState.currentSort
      }
    }));

    console.log('[Instant Search Filter BS] Filters applied:', FilterState.selectedFilters);
  }

  /**
   * Public API
   */
  window.InstantSearchFilterBS = {
    init: init,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    clearAllFilters: clearAllFilters,
    getFilters: function() { return FilterState.selectedFilters; },
    getSort: function() { return FilterState.currentSort; },
    setSearchTerm: function(term) { 
      FilterState.currentSearchTerm = term;
      fetchFilterTree(term);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when search drawer opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-search-custom-trigger]')) {
      console.log('[Instant Search Filter BS] Search drawer trigger clicked, re-caching elements...');
      setTimeout(function() {
        cacheElements();
        console.log('[Instant Search Filter BS] Elements re-cached:', elements);
        
        // Also add direct click handler to filter button as backup
        var filterBtn = document.getElementById('instant-search-open-filter-drawer');
        if (filterBtn && !filterBtn.hasAttribute('data-filter-bs-bound')) {
          filterBtn.setAttribute('data-filter-bs-bound', 'true');
          filterBtn.addEventListener('click', function(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            console.log('[Instant Search Filter BS] Direct filter button click!');
            openDrawer();
          });
          console.log('[Instant Search Filter BS] Direct click handler added to filter button');
        }
      }, 500);
    }
  });

})();

// Additional global click handler as ultimate fallback
document.addEventListener('DOMContentLoaded', function() {
  console.log('[Instant Search Filter BS] DOMContentLoaded - adding global fallback handler');
  
  // Global click handler for filter button
  document.body.addEventListener('click', function(e) {
    var btn = e.target;
    
    // Check if clicked element or its parent is the filter button
    while (btn && btn !== document.body) {
      if (btn.id === 'instant-search-open-filter-drawer') {
        console.log('[Instant Search Filter BS] Global fallback: Filter button clicked!');
        e.preventDefault();
        e.stopPropagation();
        
        // Open the drawer
        var drawer = document.getElementById('instant_search_filter_bs_drawer');
        var overlay = document.getElementById('instant_search_filter_bs_overlay');
        
        if (drawer) {
          drawer.classList.add('instant_search_filter_bs_drawer_active');
          console.log('[Instant Search Filter BS] Drawer activated');
        } else {
          console.error('[Instant Search Filter BS] Drawer not found!');
        }
        
        if (overlay) {
          overlay.classList.add('instant_search_filter_bs_overlay_active');
        }
        
        document.body.style.overflow = 'hidden';
        
        // Try to use the API if available
        if (window.InstantSearchFilterBS && window.InstantSearchFilterBS.openDrawer) {
          window.InstantSearchFilterBS.openDrawer();
        }
        
        return false;
      }
      btn = btn.parentElement;
    }
  }, true);
});

